import React from 'react';
import SEO from "../components/SEO/SEO";
import FallingLettersTextBox from '../components/fallingLettersTextBox/FallingLettersTextBox';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useSigilContext } from '../context/sigilContext';
import { useNavigate, Link } from 'react-router-dom';


const Home = () => {
    const navigate = useNavigate();
    const {
        setSigilName,
        setShapes,
        setEditIndex,
        text,
        setText,
        setCriptoText,
        i18n
    } = useSigilContext()

    const cleanContext = () => {
        setShapes([]);
        setSigilName('');
        setEditIndex(undefined);
        processText()
        navigate('/drawing');
    }

    React.useEffect(() => {
        setText('');
        setCriptoText('')
    }, [setText, setCriptoText]);

    const processText = () => {
        const uniqueLetters = [];
        const newFallingLetters = [];

        text.toLocaleUpperCase().split('').forEach((letter, index) => {
            if (!uniqueLetters.includes(letter) || letter === ' ') {
                uniqueLetters.push(letter);
            } else {
                newFallingLetters.push({ letter, index });
            }
        });

        // setFallingLetters(newFallingLetters);
        setText(uniqueLetters.join('')); // Actualizar el texto para eliminar repetidas
        // setCriptoText(uniqueLetters.join(''))
        // setTimeout(() => {
        //   setFallingLetters([]);
        setCriptoText(uniqueLetters.join(''))
        // }, 100);
    };

    const translate = i18n.creation;

    return (
        <>
            <SEO
                title="Magia del Caos | Crea tus sigilos"
                description="Herramienta online para crear, visualizar y cargar tus sigilos de manera fácil y efectiva."
                name="Magia del Caos"
                type="website"
            />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                marginX: '16px',
                width: { sx: '100%', md: '50%' },
                marginLeft: { md: '25%' }
            }}>
                <h1>{translate.title}</h1>
                <h3>{translate.description}</h3>
                <FallingLettersTextBox />
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                    <Button
                        variant='contained'
                        disabled={text === ''}
                        onClick={() => {
                            cleanContext();
                        }}
                    >
                        {translate.createButton}
                    </Button>
                </Box>
            </Box>

            {/* Enhanced SEO Content Section */}
            <Box component="section" sx={{
                width: { xs: '90%', md: '60%' },
                margin: '60px auto 40px auto',
                padding: { xs: 2, md: 4 },
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                textAlign: 'left'
            }}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    {i18n?.homeSEO?.whatIsTitle || '¿Qué es la Magia del Caos?'}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: 'rgba(255, 255, 255, 0.85)', lineHeight: 1.8 }}>
                    {i18n?.homeSEO?.whatIsText}
                </Typography>

                <Typography variant="body1" paragraph sx={{ color: 'rgba(255, 255, 255, 0.85)', lineHeight: 1.8 }}>
                    {i18n?.homeSEO?.howItWorksText}
                </Typography>

                <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold', marginTop: 4 }}>
                    {i18n?.homeSEO?.benefitsTitle || 'Beneficios de la Sigilización'}
                </Typography>
                <Typography variant="body1" paragraph sx={{ color: 'rgba(255, 255, 255, 0.85)', lineHeight: 1.8 }}>
                    {i18n?.homeSEO?.benefitsText}
                </Typography>

                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 'bold', marginTop: 3, textAlign: 'center' }}>
                    {i18n?.homeSEO?.startNow}
                </Typography>

                {/* New Quick Access Section */}
                <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <Typography variant="h5" component="h3" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                        {i18n?.grimoire?.title || 'El Grimorio'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)', mb: 3 }}>
                        {i18n?.grimoire?.description}
                    </Typography>
                    
                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
                        {i18n?.grimoire?.articles?.slice(0, 4).map((article) => (
                            <Box 
                                key={article.id} 
                                component={Link} 
                                to={`/grimoire/${article.id}`} 
                                sx={{ 
                                    p: 2, 
                                    backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                                    borderRadius: '8px', 
                                    cursor: 'pointer',
                                    transition: '0.3s',
                                    textDecoration: 'none',
                                    display: 'block',
                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                            }}>
                                <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                                    {article.title}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    <Button component={Link} to="/grimoire" variant="outlined" sx={{ mt: 3, mr: 2 }}>
                        {i18n?.grimoire?.viewAll || 'Ir al Grimorio'}
                    </Button>
                    <Button component={Link} to="/faq" variant="text" sx={{ mt: 3, color: 'rgba(255, 255, 255, 0.6)' }}>
                        {i18n?.faq?.title || 'Preguntas Frecuentes'}
                    </Button>
                </Box>
            </Box>
        </>
    );
}

export default Home;

